import type { PendingReviewOrder } from '../model/types';

export const sortPendingReviewsByFreshness = (orders: PendingReviewOrder[]): PendingReviewOrder[] => {
  return [...orders].sort((a, b) => b.eventEndAt.getTime() - a.eventEndAt.getTime());
};
